import { apiSlice } from "../../app/api/apiSlice";

export const getBorrowerPairSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getBorrowerPair: builder.mutation({
			query: (credentials) => ({
				// includeSource: CLEARpath Dashboard — each liability carries its Source tag.
				url: `api/v1/loan/borrower_pair/${credentials.loanGuid}/${
					credentials.includeSource ? "?include_source=true" : ""
				}`,
				method: "GET",			
			}),
		}),
	}),
});

export const { useGetBorrowerPairMutation } = getBorrowerPairSlice;
